/**
 * Homepage cart take-off strip. Hidden when the cart is empty.
 */
(function (root) {
  'use strict';

  var ROOT_SEL = '[data-takeoff]';
  var MAX_THUMBS = 4;

  function itemImage(item) {
    if (!item) return '';
    if (item.featured_image && item.featured_image.url) return item.featured_image.url;
    if (item.image) return String(item.image);
    return '';
  }

  function itemAlt(item) {
    if (!item) return '';
    return String(item.product_title || item.title || 'Cart item');
  }

  function pickThumbs(items, max) {
    var list = Array.isArray(items) ? items : [];
    var limit = Math.max(0, Number(max) || MAX_THUMBS);
    var thumbs = [];
    for (var i = 0; i < list.length && thumbs.length < limit; i++) {
      var src = itemImage(list[i]);
      if (!src) continue;
      thumbs.push({ src: src, alt: itemAlt(list[i]) });
    }
    return {
      thumbs: thumbs,
      more: Math.max(0, list.length - thumbs.length),
    };
  }

  function itemLabel(count) {
    var n = Number(count) || 0;
    return n === 1 ? '1 item' : n + ' items';
  }

  function formatMoney(cents, moneyFormat) {
    var value = Number(cents);
    if (!Number.isFinite(value)) return '';
    if (root.Shopify && typeof root.Shopify.formatMoney === 'function') {
      return root.Shopify.formatMoney(value, moneyFormat || '${{amount}}');
    }
    return '$' + (value / 100).toFixed(2);
  }

  function shippingLine(totalCents, thresholdCents, moneyFormat) {
    var total = Number(totalCents) || 0;
    var need = Number(thresholdCents) || 0;
    if (need <= 0) return '';
    if (total >= need) return 'Free Shipping Unlocked!';
    return 'Add ' + formatMoney(need - total, moneyFormat) + ' for free shipping';
  }

  function shouldShow(itemCount, inDesignMode) {
    if (inDesignMode) return true;
    return Number(itemCount) > 0;
  }

  function normalizeCart(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var count = Number(cart && cart.item_count);
    if (!Number.isFinite(count)) count = items.length;
    if (count <= 0) return { item_count: 0, items: [], total_price: 0 };
    return cart;
  }

  function subscribeCart(onUpdate) {
    var events = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : root.PUB_SUB_EVENTS;
    var sub = typeof subscribe === 'function' ? subscribe : root.subscribe;
    if (!events || !events.cartUpdate || typeof sub !== 'function') return;
    sub(events.cartUpdate, function (event) {
      if (event && event.cartData) onUpdate(normalizeCart(event.cartData));
      else onUpdate(null);
    });
  }

  function inDesignMode() {
    return !!(root.Shopify && root.Shopify.designMode);
  }

  function clearNode(node) {
    while (node && node.firstChild) node.removeChild(node.firstChild);
  }

  function bind(rootEl) {
    if (!rootEl) return;
    var thumbsEl = rootEl.querySelector('[data-thumbs]');
    var moreEl = rootEl.querySelector('[data-more]');
    var countEl = rootEl.querySelector('[data-count-label]');
    var totalEl = rootEl.querySelector('[data-total]');
    var shipEl = rootEl.querySelector('[data-ship]');
    var sectionEl = rootEl.closest('.shopify-section');
    var moneyFormat = rootEl.getAttribute('data-money-format') || '${{amount}}';
    var threshold = Number(rootEl.getAttribute('data-ship-threshold') || 0);

    function applyVisibility(itemCount) {
      var show = shouldShow(itemCount, inDesignMode());
      rootEl.hidden = !show;
      if (sectionEl) sectionEl.hidden = !show;
    }

    function render(cart) {
      cart = normalizeCart(cart);
      var items = cart.items;
      var count = cart.item_count;
      var total = Number(cart.total_price) || 0;
      var picked = pickThumbs(items, MAX_THUMBS);

      if (countEl) countEl.textContent = itemLabel(count);
      if (totalEl) totalEl.textContent = formatMoney(total, moneyFormat);
      if (shipEl) {
        var line = shippingLine(total, threshold, moneyFormat);
        shipEl.textContent = line;
        shipEl.hidden = !line;
      }
      if (thumbsEl) {
        if (moreEl && moreEl.parentNode) moreEl.parentNode.removeChild(moreEl);
        clearNode(thumbsEl);
        for (var i = 0; i < picked.thumbs.length; i++) {
          var img = root.document.createElement('img');
          img.className = 'd1-takeoff__thumb';
          img.src = picked.thumbs[i].src;
          img.alt = picked.thumbs[i].alt;
          img.width = 64;
          img.height = 64;
          thumbsEl.appendChild(img);
        }
        if (moreEl) {
          moreEl.hidden = picked.more < 1;
          moreEl.textContent = '+' + picked.more;
          thumbsEl.appendChild(moreEl);
        }
      }
      applyVisibility(count);
    }

    function refresh() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('cart');
          return res.json();
        })
        .then(render)
        .catch(function () {});
    }

    subscribeCart(function (cart) {
      if (cart) render(cart);
      else refresh();
    });

    applyVisibility(Number(rootEl.getAttribute('data-item-count') || 0));
  }

  function init() {
    var nodes = root.document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < nodes.length; i++) bind(nodes[i]);
  }

  if (root.document.readyState === 'loading') {
    root.document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  root.D1CartTakeoff = {
    pickThumbs: pickThumbs,
    itemLabel: itemLabel,
    shippingLine: shippingLine,
    shouldShow: shouldShow,
    formatMoney: formatMoney,
    normalizeCart: normalizeCart,
  };
})(typeof window !== 'undefined' ? window : globalThis);
